/** Cytoscape reads *-dash-pattern only in its `dashed` branch, never for `dotted`. */
export function cytoscapeStrokeStyle(
  style: string | null | undefined
): 'solid' | 'dashed' {
  const normalized = String(style ?? 'solid').toLowerCase();
  return normalized === 'dashed' || normalized === 'dotted' ? 'dashed' : 'solid';
}
